(ns frontend.ui.component.lp-portal.report.body.sparkmind.holding.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller :refer [block-table-raw-data->editable-data
                                                                                         invest-europe-editable-data->raw-data
                                                                                         invest-europe-table-raw-data->editable-data]]))

(defn ->ui-data
  [{:keys [report-data] :as props}]
  {:holding-name   (get-in report-data [:holding-name])
   :reference-date (get-in report-data [:reference-date])
   :report-id      (:report-id props)
   :overview       {:case-overview       (report-ctl/rich-content
                                          props
                                          :case-overview-text)
                    :general-information (->> (report-ctl/with-footnote
                                                props
                                                :general-information-footnotes
                                                (:general-information report-data))
                                              (report-ctl/with-editable-tables (merge {:fixed-columns? true
                                                                                       :fixed-labels? true} props)
                                                :general-information
                                                block-table-raw-data->editable-data
                                                invest-europe-editable-data->raw-data))}
   :business-and-general-kpi (->> (report-ctl/with-footnote
                                    props
                                    :business-and-general-kpi-footnotes
                                    (:business-and-general-kpi report-data))
                                  (report-ctl/with-editable-tables props :business-and-general-kpi
                                    invest-europe-table-raw-data->editable-data
                                    invest-europe-editable-data->raw-data))
   :current-key-impact-indicators (->> (report-ctl/with-footnote
                                         props
                                         :current-key-impact-indicators-footnotes
                                         (:current-key-impact-indicators report-data))
                                       (report-ctl/with-editable-tables props :current-key-impact-indicators
                                         invest-europe-table-raw-data->editable-data
                                         invest-europe-editable-data->raw-data))})
